import { NAV_MENU_TYPE } from '../../types';

interface HistoryRouterData {
    router: string;
    module: NAV_MENU_TYPE;
}

/**
 * @param historyRowData 历史记录类型
 * @param detailId 历史记录ID
 * @returns 历史记录数据，用于同一模块内使用vue-router跳转的路由数据
 */
export const getHistoryRouterData = (historyRowData: NAV_MENU_TYPE, detailId: string): HistoryRouterData => {
    switch (historyRowData) {
    case NAV_MENU_TYPE.SEEK_SEARCH:
        return {
            router: `/page/${detailId}`,
            module: NAV_MENU_TYPE.HOME,
        };
    case NAV_MENU_TYPE.TECH_MIND:
        return {
            router: `/board/${detailId}`,
            module: NAV_MENU_TYPE.TECH_MIND,
        };
    case NAV_MENU_TYPE.RD_TECH_MIND:
        return {
            router: `/chat/${detailId}`,
            module: NAV_MENU_TYPE.RD_TECH_MIND,
        };
    case NAV_MENU_TYPE.TECH_RESEARCH:
        return {
            router: `/report/${detailId}`,
            module: NAV_MENU_TYPE.TECH_RESEARCH,
        };
    case NAV_MENU_TYPE.TECH_FMEA:
        return {
            router: `/page/${detailId}`,
            module: NAV_MENU_TYPE.TECH_FMEA,
        };
    case NAV_MENU_TYPE.WORK_PROJECT:
        return {
            router: `/graph/${detailId}`,
            module: NAV_MENU_TYPE.WORK_PROJECT,
        };
    case NAV_MENU_TYPE.TRIZ_MIND:
        return {
            router: `/result/${detailId}`,
            module: NAV_MENU_TYPE.TRIZ,
        };
    case NAV_MENU_TYPE.TRIZ_PRO:
        return {
            router: `/result/${detailId}`,
            module: NAV_MENU_TYPE.TRIZ_PRO,
        };
    default:
        return {
            router: '',
            module: NAV_MENU_TYPE.HOME,
        };
    }
}
